module.exports = __webpack_public_path__ + "static/img/ctswugcqi.c348e444.png";